/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".itm-description[_ngcontent-%COMP%]{display:inline-block;margin-left:1em;font-style:italic}"];
export { styles as styles };
